import React, { useState, useEffect } from 'react';
import "../aboutus/aboutus.css";
import MFooter from '../../Components/Main-Footer/MFooter';
import HNavbar from '../../Components/Navbar/HNavbar';

function AboutUs() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="abtus-sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <div className="abtus-hero-tag">ABOUT US</div>
                            <h1 className="abtus-hero-title">
                                Engineering a Quieter Tomorrow.
                            </h1>
                            <p className="abtus-hero-desc">
                                Acoustical Surfaces Industries LLP is a leading manufacturer of high-performance acoustic solutions under the brand Sound Barrier. With over two decades of industry experience, we design, engineer and manufacture innovative acoustic systems that reduce noise, protect communities and enhance quality of life. Our solutions are trusted across infrastructure, industrial and commercial projects worldwide.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container how-it-works">

                {/* <!-- HEADING --> */}
                <div className="process-heading">
                    <h3>SOUNDBARRIER</h3>
                    <p>is a brand of <span className='sb-span'>ACOUSTICAL SURFACES INDUSTRIES LLP</span><br />Manufactured at our state-of-the-art
                        facility in Tiruppur, Tamil Nadu, India.</p>
                </div>

                {/* <!-- ROW 1: PROCESS STEPS --> */}
                <div className="abt-process-row">

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-crosshairs"></i></div>
                        <div className="step-text">
                            <strong>ENGINEERED FOR PERFORMANCE</strong>
                            <p>Precision engineered systems for superior noise control.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-shield-halved"></i></div>
                        <div className="step-text">
                            <strong>BUILT TO LAST</strong>
                            <p>High quality materials and rigorous quality control.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-leaf"></i></div>
                        <div className="step-text">
                            <strong>SUSTAINABLE BY CHOICE</strong>
                            <p>Responsible manufacturing with a focus on a sustainable future.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-users"></i></div>
                        <div className="step-text">
                            <strong>PARTNERED FOR SUCCESS</strong>
                            <p>Collaborative approach from design to installation support.</p>
                        </div>
                    </div>

                </div>
            </section>

            <section className="container how-it-works">

                {/* <!-- HEADING --> */}
                <div className="process-heading">
                    <h3>OUR STRENGTH</h3>
                </div>

                {/* <!-- ROW 1: PROCESS STEPS --> */}
                <div className="abt-process-row">

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-gear"></i></div>
                        <div className="step-text">
                            <strong>20+ Years of Experience</strong>
                            <p>Deep industry knowledge technical expertise</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-building"></i></div>
                        <div className="step-text">
                            <strong>1200+ Projects Completed</strong>
                            <p>Successfully delivered across 10+ countries.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-clipboard-check"></i></div>
                        <div className="step-text">
                            <strong>End-to-End Solutions</strong>
                            <p>From acoustic design and engineering to manufacturing and supply</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-flask"></i></div>
                        <div className="step-text">
                            <strong>In-House Testing & R&D</strong>
                            <p>Advanced testing facility for product validation and continuous innovation.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="abt-process-step">
                        <div className="step-icon"><i className="fa-solid fa-award"></i></div>
                        <div className="step-text">
                            <strong>International Standards</strong>
                            <p>Products manufactured and tested in accordance with global standards.</p>
                        </div>
                    </div>

                </div>
                {/* 
                <!-- ROW 2: BENEFITS STRIP --> */}
                <div className="abt-benefits-row pt-5">

                    <div className="abt-benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-users"></i></div>
                        <div className="benefit-text">
                            <strong>50+ Team Members</strong>
                            <p>Experienced engineers. technicians & professionals.</p>
                        </div>
                    </div>

                    <div className="abt-benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-industry"></i></div>
                        <div className="benefit-text">
                            <strong>50,000+ m² Manufacturing Facility</strong>
                            <p>Located in Tiruppur, Tamil Nadu, India.</p>
                        </div>
                    </div>

                    <div className="abt-benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-earth-americas"></i></div>
                        <div className="benefit-text">
                            <strong>10+ Countries Served</strong>
                            <p>Global reach with local understanding</p>
                        </div>
                    </div>

                    <div className="abt-benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-shield-halved"></i></div>
                        <div className="benefit-text">
                            <strong>Quality Assurance</strong>
                            <p>Strict quality control at every stage for consistent performance</p>
                        </div>
                    </div>

                    <div className="abt-benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-landmark"></i></div>
                        <div className="benefit-text">
                            <strong>Proudly Made in India</strong>
                            <p>Designed, engineered and manufactured in India for the world</p>
                        </div>
                    </div>

                </div>

            </section>



            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default AboutUs